// src/components/auth/GoogleAuthButton.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';

interface GoogleAuthButtonProps {
  onLoading?: (loading: boolean) => void;
}

declare global {
  interface Window {
    google?: any;
  }
}

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ onLoading }) => {
  const navigate = useNavigate();
  const { setGoogleToken } = useAuth();
  
  useEffect(() => {
    // Załaduj Google Identity Services
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    
    script.onload = () => {
      if (window.google) {
        const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '718148264793-652ttnfun23h3vbt84u4e5tq04cp7okk.apps.googleusercontent.com';
        console.log('Google Auth Client ID:', clientId);
        
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: handleCredentialResponse,
          auto_select: false,
          cancel_on_tap_outside: true,
        });
        
        // Renderuj przycisk
        window.google.accounts.id.renderButton(
          document.getElementById('googleSignInButton'),
          {
            theme: 'filled_white',
            size: 'large',
            width: '100%',
            text: 'signin_with',
            shape: 'rectangular',
            logo_alignment: 'left'
          }
        );
      }
    };
    
    return () => {
      // Nie usuwaj skryptu przy cleanup - może powodować problemy
      // document.body.removeChild(script);
    };
  }, []);
  
  const handleCredentialResponse = async (response: any) => {
    console.log('📱 Google Sign-In response received');
    onLoading?.(true);
    
    try {
      // Google zwraca ID token (JWT), użyjmy go bezpośrednio
      const result = await setGoogleToken(response.credential);
      
      if (result.success) {
        navigate('/dashboard');
      } else {
        console.error('Login failed:', result.error || result.message);
        alert('Błąd logowania: ' + (result.message || result.error || 'Nieznany błąd'));
      }
    } catch (error) {
      console.error('Error during login:', error);
      alert('Wystąpił błąd podczas logowania. Spróbuj ponownie.');
    } finally {
      onLoading?.(false);
    }
  };
  
  return (
    <div id="googleSignInButton" className="w-full" />
  );
};
